import { render, staticRenderFns } from "./SendMails.vue?vue&type=template&id=19230140&"
import script from "./SendMails.vue?vue&type=script&lang=ts&"
export * from "./SendMails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports